import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.concat.js";
import UA from '../ua';
import Url from './url';
import KNB from '@dp/knb';
export function compareVersions(version1, version2) {
  // 将版本号拆分为数组
  var v1 = version1.split('.').map(Number);
  var v2 = version2.split('.').map(Number);
  // 获取最长的版本号长度
  var maxLength = Math.max(v1.length, v2.length);
  // 循环比较每一部分的版本号
  for (var i = 0; i < maxLength; i++) {
    var num1 = v1[i] || 0; // 如果v1长度不够，补0
    var num2 = v2[i] || 0; // 如果v2长度不够，补0
    if (num1 > num2) {
      return true;
    } else if (num1 < num2) {
      return false;
    }
  }
  // 如果所有部分都相等，返回true
  return true;
}
export function checkMRNJumpDetailConfig(url) {
  var closePage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  try {
    if (!UA.isNative) {
      return false;
    }
    if (!url) return false;
    // h5详情页正则匹配
    if (!/^https?:\/\/h5\.(dian|51)ping\.com\/app\/myshow.*#\/detail\/\d+.*$/.test(url)) {
      return false;
    }
    // 旧上单项目不支持mrn跳转
    if (!url.includes('isNewPage=true')) return false;
    // isFromMrn 为true 时，不支持mrn跳转，避免死循环
    if (url.includes('isFromMrn=true')) return false;
    if (!isAppSupportMrn()) {
      return false;
    }
    if (!window.Drip || !window.MRN_JUMP_DETAIL_CONFIG) {
      return false;
    }
    var result = url.match(/.*#\/detail\/(\d+).*/);
    // 提取项目id参数
    if (!result || !result[1]) {
      return false;
    }
    var performanceId = +result[1];
    // 非数字id不支持mrn跳转
    if (!Number.isInteger(performanceId)) return false;
    // 提取品类id参数
    var categoryResult = url.match(/.*[?&]categoryId=(\d+).*/);
    var categoryId = categoryResult && categoryResult[1] ? +categoryResult[1] : -1;
    var _window$MRN_JUMP_DETA = window.MRN_JUMP_DETAIL_CONFIG,
      openMrnJump = _window$MRN_JUMP_DETA.openMrnJump,
      whiteProjectIdList = _window$MRN_JUMP_DETA.whiteProjectIdList,
      blackProjectIdList = _window$MRN_JUMP_DETA.blackProjectIdList,
      categoryIdList = _window$MRN_JUMP_DETA.categoryIdList,
      sellChannelWhiteList = _window$MRN_JUMP_DETA.sellChannelWhiteList,
      forceUpdateForDetail = _window$MRN_JUMP_DETA.forceUpdateForDetail,
      detailMiniVersion = _window$MRN_JUMP_DETA.detailMiniVersion;
    var isInBlackList = blackProjectIdList.includes(performanceId);
    if (isInBlackList) {
      return false;
    }
    if (Array.isArray(sellChannelWhiteList) && !sellChannelWhiteList.includes(window.Drip.constant.sellChannel)) {
      return false;
    }
    var isAllowJump = openMrnJump || Array.isArray(whiteProjectIdList) && whiteProjectIdList.includes(performanceId) || Array.isArray(categoryIdList) && categoryIdList.includes(categoryId);
    if (isAllowJump) {
      // 跳转mrn 详情页面
      var H5Url = Url.parseUrl(url);
      var h5QueryParams = H5Url.query || {};
      var h5HashQueryParams = {};
      if (H5Url.hash && H5Url.hash.includes('?')) {
        h5HashQueryParams = Url.parseQuery(H5Url.hash.split('?')[1]) || {};
      }
      var mrnParamsObj = Object.assign({}, h5QueryParams, h5HashQueryParams, {
        id: performanceId
      });
      if (forceUpdateForDetail) {
        if (detailMiniVersion) {
          mrnParamsObj.mrn_min_version = detailMiniVersion;
        } else {
          mrnParamsObj.mrn_force = 'true';
        }
      }
      var detailMrnPageUrl = getProjectDetailMrnPageUrl(new URLSearchParams(mrnParamsObj).toString());
      if (detailMrnPageUrl) {
        if (closePage) {
          KNB.jumpPage({
            url: detailMrnPageUrl,
            fail: function fail(e) {
              window.owl && window.owl('addError', e);
              window.location.href = detailMrnPageUrl;
            }
          });
        } else {
          KNB.openPage({
            url: detailMrnPageUrl,
            fail: function fail(e) {
              window.owl && window.owl('addError', e);
              window.location.href = detailMrnPageUrl;
            }
          });
        }
        return true;
      }
      return false;
    }
    return isAllowJump;
  } catch (e) {
    // 拼接异常名
    try {
      e.message = "\u8BE6\u60C5\u9875MRN\u94FE\u63A5\u5904\u7406\u9519\u8BEF-".concat(e.message);
    } catch (_) {
      // catch 不需要处理
    }
    window.owl && window.owl('addError', e);
    return false;
  }
}
export function isAppSupportMrn() {
  if (!UA.IS_MAOYAN && !UA.IS_MEITUAN && !UA.IS_DIANPING) {
    return false;
  }
  if (UA.IS_MEITUAN && !compareVersions(UA.appVersion, '11.7.200')) {
    // 美团app 最低mrn3.x版本 11.7.200
    return false;
  }
  if (UA.IS_MAOYAN && !compareVersions(UA.appVersion, '9.63.0')) {
    // 猫眼app ios 版本，从9.63.0 开始给yanchu.maoyan.com 域名请求添加验签，所以在低版本走h5,高版本走mrn
    return false;
  }
  if (UA.IS_DIANPING && !compareVersions(UA.appVersion, '10.43.0')) {
    // 点评app 最低mrn3.x版本 10.43.0
    return false;
  }
  return true;
}
export function getMrnBaseUrl() {
  if (UA.IS_MAOYAN) {
    return 'meituanmovie://www.meituan.com/mrn';
  } else if (UA.IS_MEITUAN) {
    return 'imeituan://www.meituan.com/mrn';
  } else if (UA.IS_DIANPING) {
    return 'dianping://mrn';
  } else {
    return '';
  }
}
export function getProjectDetailMrnPageUrl(paramsStr) {
  var baseURL = getMrnBaseUrl();
  if (!baseURL) return;
  return "".concat(baseURL, "?mrn_biz=maoyanshow&mrn_entry=project-detail&mrn_component=detail-page&").concat(paramsStr);
}